<div class="main-window">
  <label style="padding: 30px">{{'ERRORS.SORRY' | translate}}</label>
</div>
